import { render, staticRenderFns } from "./storageRoomAction.vue?vue&type=template&id=eb66dcd8&scoped=true"
import script from "./storageRoomAction.vue?vue&type=script&lang=js"
export * from "./storageRoomAction.vue?vue&type=script&lang=js"
import style0 from "./storageRoomAction.vue?vue&type=style&index=0&id=eb66dcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb66dcd8",
  null
  
)

export default component.exports